<template>
  <el-dialog title="Price List" :visible.sync="visible" @close="closeDialog" class="table">
    <el-table :data="tableData" class="table">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="Website" prop="webType" class="font-bold"></el-table-column>
      <el-table-column label="Price" prop="price" class="font-red"></el-table-column>
      <el-table-column label="Url">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.enUrl != ''"
            type="success"
            size="small"
            @click="linkOverseas(scope.row)"
          >Visit</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length"
      v-if="tableData.length > 10"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import { chargesList } from "@/api/downLoad";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val;
        if (val) this.getTableDatas();
      },
      immediate: true,
    },
  },
  data() {
    return {
      visible: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    async getTableDatas() {
      try {
        const result = await chargesList();
        this.tableData = result;
      } catch (error) {
        console.error("Get charges list error:", error);
      }
    },
    linkOverseas(row) {
      window.open(row.enUrl);
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
